import React from 'react'
import { Outlet } from 'react-router-dom'

 const WebsiteSettingsLayout = () => {
  return (
    <div><Outlet/></div>
  )
}
export default WebsiteSettingsLayout;